import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, } from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate: () => Promise<boolean>;
  isPopupShown: boolean;
}

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<CanComponentDeactivate> {
  private calledPromise: Promise<boolean> | null = null;

  async canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const pending = this.calledPromise ?? component.canDeactivate();
    this.calledPromise = pending;

    const result = await pending;
    this.calledPromise = null;
    return result;
  }
}
